import api from "./api";
const svc = {
  listar:          (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/transacoes?${qs}`); },
  buscarPorId:     id     => api("GET",`/transacoes/${id}`),
  criar:           data   => api("POST","/transacoes",data),
  atualizar:       (id,data) => api("PUT",`/transacoes/${id}`,data),
  confirmar:       id     => api("PATCH",`/transacoes/${id}/confirmar`,{}),
  conciliar:       (id,dtConciliacao) => api("PATCH",`/transacoes/${id}/conciliar`,{dtConciliacao}),
  cancelar:        id     => api("PATCH",`/transacoes/${id}/cancelar`,{}),
  conciliarLote:   (ids,dtConciliacao) => api("POST","/transacoes/conciliar-lote",{ids,dtConciliacao}),
  importarCNAB:    data   => api("POST","/transacoes/importar-cnab",data),
  extrato:         (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/transacoes/extrato?${qs}`); },
  naoConciliadas:  id     => api("GET",`/transacoes/nao-conciliadas?idContaBancaria=${id}`),
};
export default svc;
